import { SimpleShowLayout, Show, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";

const ShowDirections = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за професионално направление"
      actions={<BackButtonToolbar />}
    >
      <SectionTitle
        title="Информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />

      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <SimpleShowLayout>
            <TextField
              label="Име"
              source="nameBg"
            />
          </SimpleShowLayout>
        </Grid>
      </Grid>
    </Show>
  );
};

export default ShowDirections;
